(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordion-2-switch-control-3-light-switches"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const headers = document.querySelectorAll(".accordion-header");
    headers.forEach(header => {
      header.addEventListener("click", () => {
        const item = header.parentElement;
        const openItem = document.querySelector(".accordion-item.active");
        if (openItem && openItem !== item) {
          openItem.classList.remove("active");
        }
        item.classList.toggle("active");
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["accordion-builders-overview"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const headers = document.querySelectorAll(".accordion-header");
    headers.forEach(header => {
      header.addEventListener("click", () => {
        const item = header.parentElement;
        const openItem = document.querySelector(".accordion-item.active");
        if (openItem && openItem !== item) {
          openItem.classList.remove("active");
        }
        item.classList.toggle("active");
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["accordion-builders-system"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const headers = document.querySelectorAll(".accordion-header");
    headers.forEach(header => {
      header.addEventListener("click", () => {
        const item = header.parentElement;
        const openItem = document.querySelector(".accordion-item.active");
        if (openItem && openItem !== item) {
          openItem.classList.remove("active");
        }
        item.classList.toggle("active");
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["accordion-custom-installer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const headers = document.querySelectorAll(".accordion-header");
    headers.forEach(header => {
      header.addEventListener("click", () => {
        const item = header.parentElement;
        const openItem = document.querySelector(".accordion-item.active");
        if (openItem && openItem !== item) {
          openItem.classList.remove("active");
        }
        item.classList.toggle("active");
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["accordion-mobile-app"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const headers = document.querySelectorAll(".accordion-header");
    headers.forEach(header => {
      header.addEventListener("click", () => {
        const item = header.parentElement;
        const openItem = document.querySelector(".accordion-item.active");
        if (openItem && openItem !== item) {
          openItem.classList.remove("active");
        }
        item.classList.toggle("active");
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["accordion-multifamily-overview"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const headers = document.querySelectorAll(".accordion-header");
    headers.forEach(header => {
      header.addEventListener("click", () => {
        const item = header.parentElement;
        const openItem = document.querySelector(".accordion-item.active");
        if (openItem && openItem !== item) {
          openItem.classList.remove("active");
        }
        item.classList.toggle("active");
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["accordion-multifamily-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const headers = document.querySelectorAll(".accordion-header");
    headers.forEach(header => {
      header.addEventListener("click", () => {
        const item = header.parentElement;
        const openItem = document.querySelector(".accordion-item.active");
        if (openItem && openItem !== item) {
          openItem.classList.remove("active");
        }
        item.classList.toggle("active");
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["accordion-plug-in-control"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const headers = document.querySelectorAll(".accordion-header");
    headers.forEach(header => {
      header.addEventListener("click", () => {
        const item = header.parentElement;
        const openItem = document.querySelector(".accordion-item.active");
        if (openItem && openItem !== item) {
          openItem.classList.remove("active");
        }
        item.classList.toggle("active");
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["accordion-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const headers = document.querySelectorAll(".accordion-header");
    headers.forEach(header => {
      header.addEventListener("click", () => {
        const item = header.parentElement;
        const openItem = document.querySelector(".accordion-item.active");
        if (openItem && openItem !== item) {
          openItem.classList.remove("active");
        }
        item.classList.toggle("active");
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["accordion-property-manager-experience"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const headers = document.querySelectorAll(".accordion-header");
    headers.forEach(header => {
      header.addEventListener("click", () => {
        const item = header.parentElement;
        const openItem = document.querySelector(".accordion-item.active");
        if (openItem && openItem !== item) {
          openItem.classList.remove("active");
        }
        item.classList.toggle("active");
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["accordion-resident-experience"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const headers = document.querySelectorAll(".accordion-header");
    headers.forEach(header => {
      header.addEventListener("click", () => {
        const item = header.parentElement;
        const openItem = document.querySelector(".accordion-item.active");
        if (openItem && openItem !== item) {
          openItem.classList.remove("active");
        }
        item.classList.toggle("active");
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["accordion-ring-brilliant-better-together-nav"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const headers = document.querySelectorAll(".accordion-header");
    headers.forEach(header => {
      header.addEventListener("click", () => {
        const item = header.parentElement;
        const openItem = document.querySelector(".accordion-item.active");
        if (openItem && openItem !== item) {
          openItem.classList.remove("active");
        }
        item.classList.toggle("active");
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["accordion-second-generation-1-switch-panel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const headers = document.querySelectorAll(".accordion-header");
    headers.forEach(header => {
      header.addEventListener("click", () => {
        const item = header.parentElement;
        const openItem = document.querySelector(".accordion-item.active");
        if (openItem && openItem !== item) {
          openItem.classList.remove("active");
        }
        item.classList.toggle("active");
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["accordion-second-generation-2-switch-panel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const headers = document.querySelectorAll(".accordion-header");
    headers.forEach(header => {
      header.addEventListener("click", () => {
        const item = header.parentElement;
        const openItem = document.querySelector(".accordion-item.active");
        if (openItem && openItem !== item) {
          openItem.classList.remove("active");
        }
        item.classList.toggle("active");
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["accordion-second-generation-4-switch-panel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const headers = document.querySelectorAll(".accordion-header");
    headers.forEach(header => {
      header.addEventListener("click", () => {
        const item = header.parentElement;
        const openItem = document.querySelector(".accordion-item.active");
        if (openItem && openItem !== item) {
          openItem.classList.remove("active");
        }
        item.classList.toggle("active");
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["accordion-smart-dimmer-switch"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const headers = document.querySelectorAll(".accordion-header");
    headers.forEach(header => {
      header.addEventListener("click", () => {
        const item = header.parentElement;
        const openItem = document.querySelector(".accordion-item.active");
        if (openItem && openItem !== item) {
          openItem.classList.remove("active");
        }
        item.classList.toggle("active");
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["accordion-smart-home-control"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const headers = document.querySelectorAll(".accordion-header");
    headers.forEach(header => {
      header.addEventListener("click", () => {
        const item = header.parentElement;
        const openItem = document.querySelector(".accordion-item.active");
        if (openItem && openItem !== item) {
          openItem.classList.remove("active");
        }
        item.classList.toggle("active");
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["accordion-smart-lighting-control"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const headers = document.querySelectorAll(".accordion-header");
    headers.forEach(header => {
      header.addEventListener("click", () => {
        const item = header.parentElement;
        const openItem = document.querySelector(".accordion-item.active");
        if (openItem && openItem !== item) {
          openItem.classList.remove("active");
        }
        item.classList.toggle("active");
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["accordion-smart-plug"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const headers = document.querySelectorAll(".accordion-header");
    headers.forEach(header => {
      header.addEventListener("click", () => {
        const item = header.parentElement;
        const openItem = document.querySelector(".accordion-item.active");
        if (openItem && openItem !== item) {
          openItem.classList.remove("active");
        }
        item.classList.toggle("active");
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["accordion-sonos-detail"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const headers = document.querySelectorAll(".accordion-header");
    headers.forEach(header => {
      header.addEventListener("click", () => {
        const item = header.parentElement;
        const openItem = document.querySelector(".accordion-item.active");
        if (openItem && openItem !== item) {
          openItem.classList.remove("active");
        }
        item.classList.toggle("active");
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["accordion-standalone"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const headers = document.querySelectorAll(".accordion-header");
    headers.forEach(header => {
      header.addEventListener("click", () => {
        const item = header.parentElement;
        const openItem = document.querySelector(".accordion-item.active");
        if (openItem && openItem !== item) {
          openItem.classList.remove("active");
        }
        item.classList.toggle("active");
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["accordion-student-housing-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const headers = document.querySelectorAll(".accordion-header");
    headers.forEach(header => {
      header.addEventListener("click", () => {
        const item = header.parentElement;
        const openItem = document.querySelector(".accordion-item.active");
        if (openItem && openItem !== item) {
          openItem.classList.remove("active");
        }
        item.classList.toggle("active");
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-accordion"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const headers = document.querySelectorAll(".accordion-header");
  headers.forEach(header => {
    header.addEventListener("click", () => {
      const item = header.parentElement;
      const openItem = document.querySelector(".accordion-item.active");
      if (openItem && openItem !== item) {
        openItem.classList.remove("active");
      }
      item.classList.toggle("active");
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
